<template>
  <li class="item">
    <div class="item-wrapper">
      <div class="basic-info">
        <div class="basic-info-wrapper">
          <div class="basic-info-section">
            <h2 class="name">{{ result.FullName }}</h2>
            <span class="title">{{ result.Title }}</span>
          </div>
          <div class="basic-info-section"></div>
          <div class="basic-info-section">
            <span class="phone-info">
              Dept <span class="phone-number">{{ result.Department }}</span>
            </span>
          </div>
          <div class="basic-info-section">
            <span class="phone-info">
              Phone
              <span class="phone-number">
                <a :href="'tel:' + result.PhoneNumber">{{ result.PhoneNumber }}</a></span
              >
            </span>
          </div>
        </div>

        <span block="" v-b-toggle="'accordion-' + this._uid" class="item-accordion-toggle">
          <span class="item-open lmc-icon icon-angle-up"></span>
          <span class="item-closed lmc-icon icon-angle-down"></span>
        </span>
      </div>
      <b-collapse :id="'accordion-' + this._uid" accordion="my-accordion" role="tabpanel">
        <div class="additional-info">
          <div class="info-block">
            <div class="info-section photo">
              <img v-if="result.Image" :src="result.Image" :alt="result.FullName" />
              <img v-else="" src="/images/contact-placeholder.png" :alt="result.FullName" />
            </div>

            <!-- Duplicate of info-top for handling responsive design -->
            <div class="info-section hide-desktop">
              <a :href="'/members/directory/vcard/' + result.ContactGuid" class="v-card" title="Download Contact Card"> <span class="lmc-icon icon-address-card"></span> Download Contact Card </a>
              <div class="info-item">
                <h4>Department</h4>
                <p>{{ result.Department }}</p>
              </div>
              <div class="info-item">
                <h4>Email</h4>
                <p>
                  <a :href="'mailto:' + result.Email" :title="'Email' + result.FullName">{{ result.Email }}</a>
                </p>
              </div>
            </div>
          </div>
          <div class="info-block">
            <!-- Duplicate of info-top for handling responsive design -->
            <div class="info-section hide-mobile">
              <div class="info-item v-card">
                <a :href="'/members/directory/vcard/' + result.ContactGuid" title="Download Contact Card"> <span class="lmc-icon icon-address-card"></span> Download Contact Card </a>
              </div>
              <div class="info-item">
                <h4>Department</h4>
                <p>{{ result.Department }}</p>
              </div>
              <div class="info-item">
                <h4>Email</h4>
                <p>
                  <a :href="'mailto:' + result.Email" :title="'Email' + result.FullName">{{ result.Email }}</a>
                </p>
              </div>
            </div>

            <div class="info-section">
              <div v-if="result.Responsibilities" class="info-item">
                <h4>Responsibilities</h4>
                <p>
                  {{ result.Responsibilities }}
                </p>
              </div>

              <div v-if="result.AboutMe" class="info-item">
                <h4>About Me</h4>
                <p v-html="result.AboutMe"></p>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>
